import { PRE_CHECK_MACHINE_STATES } from './constants'

export default function studentPreCheckFlow(studentPreChecksState){

    const { currentCheck, settings } = studentPreChecksState

    const requiresAudioChecks = settings.shouldDoAudioChecks
    const requiresFirstTimeIntroduction = settings.shouldGoThroughFTUE

    function getNextPreCheckItem(){

        // these checks will always run
        if(currentCheck === PRE_CHECK_MACHINE_STATES.init) return PRE_CHECK_MACHINE_STATES.networkSpeedChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.networkSpeedChecks) return PRE_CHECK_MACHINE_STATES.networkPingChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.networkPingChecks) return PRE_CHECK_MACHINE_STATES.hardwareChecks
        // jump straight to ready to end checks
        if(!requiresAudioChecks && !requiresFirstTimeIntroduction && currentCheck === PRE_CHECK_MACHINE_STATES.hardwareChecks) return PRE_CHECK_MACHINE_STATES.end
        if(currentCheck === PRE_CHECK_MACHINE_STATES.hardwareChecks) return PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks) return PRE_CHECK_MACHINE_STATES.studentASRChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.studentASRChecks) return PRE_CHECK_MACHINE_STATES.end

        return PRE_CHECK_MACHINE_STATES.init
    }

    function getCurrentCheckItem(){
        return currentCheck
    }

    return {
        getNextPreCheckItem,
        getCurrentCheckItem
    }
}